import { useTranslation } from 'next-i18next'

import ResponsiveImage from '~/components/Image/ResponsiveImage'
import { CategoryColorClasses } from '~/bootcamp/constants/bootcamp.const'
import ActivitiesHeader from '~/bootcamp/pages/BootcampView/BootcampContent/ActivitiesHeader'
import { BossBattleEnemy } from '~/bootcamp/components/Quiz/QuizProps.models'
import useAvatarImageUrl from '~/dashboard/hooks/useAvatarImageUrl'

import { Breakpoint, useCheckBreakpoint } from '~/utils/useBreakpoint'

import AvatarInfo from './AvatarInfo'
const mediaQuery = [{ screen: '(min-width: 280px)', width: '400px' }]
export default function BossSplashScreen({
  isQuizPage,
  subjectName,
  title,
  colorInfo,
  bossBattleEnemy,
}: {
  isQuizPage: boolean
  subjectName: string
  title: string
  colorInfo: CategoryColorClasses
  bossBattleEnemy: BossBattleEnemy
}): React.ReactElement {
  const isMobile = useCheckBreakpoint({ lt: Breakpoint.SM })
  const { t } = useTranslation('bootcampQuiz')
  const { url: avatarPng, isUnder13, isExists } = useAvatarImageUrl()

  return (
    <div className="absolute w-full h-full flex flex-col bg-purple-gdark overflow-hidden rounded-b z-30">
      <div className="p-4 z-40">
        <ActivitiesHeader
          colorInfo={colorInfo}
          isQuizPage={isQuizPage}
          isSplashScreen
          subjectName={subjectName}
          title={title}
        />
      </div>

      <h2
        className="absolute w-full mt-70 sm:mt-65 text-center font-extrabold text-transparent text-6xl sm:text-8xl bg-clip-text bg-gradient-to-b from-purple-medium-light to-purple-dark-top z-20"
        style={{ WebkitTextStroke: '3px white', filter: 'drop-shadow(5px 5px 2px black)' }}
      >
        {t('vs')}
      </h2>

      <ResponsiveImage
        alt={t('bossBackground')}
        height={600}
        imageClassName="absolute flex self-center h-full w-full md:min-w-150 top-0"
        imageWidths="400"
        mediaQuery={mediaQuery}
        srcKey="gamification/BossBattle/SplashScreen/BattleFrameBG.png"
      />
      <div className="flex justify-around">
        <div className="mt-4 ml-1 sm:ml-2">
          <AvatarInfo
            imageURL={avatarPng || ''}
            isAwsImage={!isUnder13}
            isExists={isExists}
            isMobile={isMobile}
            title={t('player')}
          />
        </div>

        <div className="mt-4">
          <AvatarInfo
            flipAvatar
            imageURL={bossBattleEnemy?.avatarImagePath?.srcKey || ''}
            isExists={Boolean(bossBattleEnemy?.avatarImagePath?.srcKey)}
            isMobile={isMobile}
            title={t('boss')}
          />
        </div>
      </div>
    </div>
  )
}
